const LilDujourVideosStatic = () => {
    return (
      <>
        <div class="music-video">  

        <div class="music-video-container">
            <iframe src="https://www.youtube.com/embed/k-7oPEbGaC8" title="lost freestyle" allowfullscreen></iframe>
          </div>
          <p class="video-title-text">
            <strong>KEANO</strong>
          </p>

        <div class="music-video-container">
            <iframe src="https://www.youtube.com/embed/8sln1klp718" title="lost freestyle" allowfullscreen></iframe>
          </div>
          <p class="video-title-text">
            <strong>Morose </strong>(prod. Mista)
          </p>

        <div class="music-video-container">
            <iframe src="https://www.youtube.com/embed/b2FZYmcVDik" title="lost freestyle" allowfullscreen></iframe>
          </div>
          <p class="video-title-text">
            <strong>Eight</strong>
          </p>

        <div class="music-video-container">
            <iframe src="https://www.youtube.com/embed/25C4IdLIRj0" title="lost freestyle" allowfullscreen></iframe>
          </div>
          <p class="video-title-text">
            <strong>Like This</strong> (prod. Goyxrd)
          </p>

        <div class="music-video-container">
            <iframe src="https://www.youtube.com/embed/esF2fVJ9zdg" title="lost freestyle" allowfullscreen></iframe>
          </div>
          <p class="video-title-text">
            <strong>LOOT</strong>
          </p>

        <div class="music-video-container">
            <iframe src="https://www.youtube.com/embed/jTwGVGjjnLM" title="lost freestyle" allowfullscreen></iframe>
          </div>
          <p class="video-title-text">
            <strong>QUOTE US</strong>
          </p>

        <div class="music-video-container">
            <iframe src="https://www.youtube.com/embed/nkQdMsfp0y8" title="lost freestyle" allowfullscreen></iframe>
          </div>
          <p class="video-title-text">
            <strong>AMEN</strong>
          </p>

        <div class="music-video-container">
            <iframe src="https://www.youtube.com/embed/DtIhFQSMGVg" title="lost freestyle" allowfullscreen></iframe>
          </div>
          <p class="video-title-text">
            <strong>ZERO</strong>
          </p>

        <div class="music-video-container">
            <iframe src="https://www.youtube.com/embed/agFi-Bglf60" title="lost freestyle" allowfullscreen></iframe>
          </div>
          <p class="video-title-text">
            <strong>CHELSEY</strong>
          </p>

        <div class="music-video-container">
            <iframe src="https://www.youtube.com/embed/-F6EolbbvMs" title="lost freestyle" allowfullscreen></iframe>
          </div>
          <p class="video-title-text">
            <strong>Blossom</strong>
          </p>

        <div class="music-video-container">
            <iframe src="https://www.youtube.com/embed/YwfcLWMmelo" title="lost freestyle" allowfullscreen></iframe>
          </div>
          <p class="video-title-text">
            <strong>CONDITIONED ASSOCIATIONS</strong>
          </p>    

          <div class="music-video-container">
            <iframe src="https://www.youtube.com/embed/3sdp4H8AweY" title="lost freestyle" allowfullscreen></iframe>
          </div>
          <p class="video-title-text">
            <strong>I Was Broke Last Weekend (Now I'm Up)</strong>
          </p>   

        <div class="music-video-container">
            <iframe src="https://www.youtube.com/embed/kErw7AAVk0k" title="lost freestyle" allowfullscreen></iframe>
          </div>
          <p class="video-title-text">
            <strong>Cruel Summer</strong>
          </p> 

          <div class="music-video-container">
            <iframe src="https://www.youtube.com/embed/hmxTwaOksgI" title="lost freestyle" allowfullscreen></iframe>
          </div>
          <p class="video-title-text">
            <strong>Shawty, Pt. 2</strong>
          </p>  

        <div class="music-video-container">
            <iframe src="https://www.youtube.com/embed/BtDMZBQVC5Y" title="lost freestyle" allowfullscreen></iframe>
          </div>
          <p class="video-title-text">
            <strong>Shawty</strong>
          </p>   

        <div class="music-video-container">
            <iframe src="https://www.youtube.com/embed/I4mOPjK6e1o" title="lost freestyle" allowfullscreen></iframe>
          </div>
          <p class="video-title-text">
            <strong>PRAY 4 LUI</strong> (prod. Lil Dujour)
          </p>                                                                                                                            
        
        </div>
      </>
    );
  };
  export default LilDujourVideosStatic;